import { Box, Modal } from "@mui/material";
import { useEffect, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import * as yup from "yup";

import { yupResolver } from "@hookform/resolvers/yup";
import {
  getAllTrainingName,
  getAllTrainingRecommendationEmpName,
  getTrainingRecommedationInfo,
  saveRecommendation,
} from "../../services/TrainingServices";
import { CloseModalIcon } from "../../../common/components/assets/commonassets/CommonAssets";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import CommonTransactionTable from "../../../common/components/CommonTable/CommonTransactionTable";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import ConfirmationModal from "../../../common/components/ConfirmationModal";
import { DeleteIcon } from "../../../assets/CommonAssets";
import {
  errorAlert,
  successAlert,
} from "../../../common/components/Toasts/CustomToasts";
import { UseCheckConsecutiveCharacters } from "../../../common/components/Custom Hooks/UseCheckConsecutiveCharacters";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "85%",
  maxHeight: "90vh",
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  display: "flex",
  flexDirection: "column",
};
const schema = yup.object().shape({
  training: yup.object().nullable().required("Training is required"),
});

const userActions = [{ permission: "Delete", isAction: true }];

const TrainingRecommendationModal = ({
  TrainingRecommendationModalOpen,
  setTrainingRecommendationModalOpen,
  selectedRow,
  setSelectedRow,
  setTrainingRecommendationList,
  TrainingRecommendationList,
  populateTable,
  setOpenBackdrop,
  openBackDrop,
}) => {
  const {
    control,
    watch,
    setValue,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      training: null,
      employee: null,
      remark: "",
    },
  });
  const training = useWatch({ control, name: "training" });
  const [tableData, setTableData] = useState([]);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [trainingNameOptions, setTrainingNameOptions] = useState([]);
  const [openPostModal, setOpenPostModal] = useState(false);
  const [employeeNameOptions, setEmployeeNameOptions] = useState([]);
  const selectedTraining = useWatch({ control, name: "training" });
  const selectedEmployee = useWatch({ control, name: "employee" });

  useEffect(() => {
    if (!selectedEmployee) return;

    setTableData((prev) => {
      const alreadyAdded = prev?.some(
        (emp) => emp?.id === selectedEmployee?.id,
      );
      if (alreadyAdded) return prev;

      return [
        ...prev,
        {
          id: selectedEmployee?.id,
          Employees: selectedEmployee?.label,
          Designation: selectedEmployee?.designation_name,
          Department: selectedEmployee?.department_name,
        },
      ];
    });
    setValue("employee", null);
  }, [selectedEmployee, setValue]);

  const handleDeleteEmployee = (row) => {
    setTableData((prev) => prev.filter((emp) => emp?.id !== row?.id));
  };

  const renderActionsEmp = (row) => (
    <button type="button" onClick={() => handleDeleteEmployee(row)}>
      <DeleteIcon sx={{ color: "#D11A2A", cursor: "pointer" }} />
    </button>
  );

  const onSubmit = () => {
    if (!selectedTraining) return;

    if (tableData.length === 0) return;
    // if (selectedRow?.editType === "Schedule") {
    //   if (!date || !fromTime || !toTime) {
    //     errorAlert("Please select Date, From Time and To Time");
    //     return;
    //   }

    //   if (
    //     selectedTraining?.trainingType?.label === "Trainer" &&
    //     !selectedTrainer
    //   ) {
    //     errorAlert("Please assign Trainer");
    //     return;
    //   }
    // }

    setOpenConfirmModal(true);
  };
  const handleSaveRecord = () => {
    let finalData = tableData.map((obj) => {
      return {
        id: selectedRow !== null ? selectedRow?.TrainingId : null,
        training: { id: training?.id || training?.value },
        employee: {
          id: obj?.id,
        },
      };
    });

    setOpenConfirmModal(false);
    // setTrainingModalOpen(false);
    setOpenBackdrop(true);
    setOpenPostModal(false);
    saveRecommendation(finalData)
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 201 || res.statusCode === 200) {
          setTrainingRecommendationModalOpen(false);
          populateTable();
          setSelectedRow(null);
          successAlert(res.message);
          setOpenBackdrop(false);
          reset();
          setTableData([]);
        }
      })
      .catch((error) => {
        errorAlert(error.message);
        setOpenBackdrop(false);
      });
  };
  useEffect(() => {
    if (selectedRow !== null) {
      setOpenBackdrop(true);
      getTrainingRecommedationInfo(selectedRow?.["TrainingId"])
        .then((res) => res.data)
        .then((res) => {
          if (res.statusCode === 200) {
            let finalData = JSON.parse(res?.result);
            finalData?.employees.length > 0 &&
              setTableData((prev) => {
                // const alreadyAdded = prev?.some(
                //   (emp) => emp?.id === selectedEmployee?.id,
                // );
                // if (alreadyAdded) return prev;

                return [...prev, ...finalData?.employees];
              });
            finalData?.training && setValue("training", finalData?.training);
            // setScheduleDetailsInfo(finalData);
          }
        })
        .catch((err) => errorAlert(err.message))
        .finally(() => setOpenBackdrop(false));
    }
  }, [selectedRow]);
  // useEffect(() => {
  //   if (selectedRow !== null) {
  //     setTableData(selectedRow?.employees);
  //     const training = trainingList.find(
  //       (obj) => obj?.id === selectedRow?.trainingId,
  //     );

  //     setValue("training", training || null);
  //   }
  // }, [selectedRow]);

  return (
    <>
      <Modal open={TrainingRecommendationModalOpen}>
        <Box sx={modalStyle}>
          <div className="flex justify-between items-center p-3 border-b">
            <h2 className="text-lg font-semibold">Training Recommendation</h2>
            <CloseModalIcon
              className="cursor-pointer"
              onClick={() => {
                setSelectedRow(null);
                setTableData([]);
                reset();

                setTrainingRecommendationModalOpen(false);
              }}
            />
          </div>

          <form
            onSubmit={handleSubmit(onSubmit)}
            className="flex-1 overflow-y-auto p-3"
          >
            {/* {(selectedRow === null || selectedRow?.editType === "Edit") && ( */}
            <div className="w-1/3">
              <SearchDropdown
                isDisabled={
                  selectedRow?.editType == "View" ||
                  selectedRow?.editType == "Schedule"
                }
                control={control}
                name="training"
                placeholder="Search by Training*"
                isSearchable={true}
                dataArray={trainingNameOptions}
                searchIcon={true}
                handleInputChange={(e) => {
                  const tempCheckChar =
                    e !== null ? UseCheckConsecutiveCharacters(e) : true;
                  if (e !== "" && tempCheckChar) {
                    getAllTrainingName(e)
                      .then((response) => {
                        setTrainingNameOptions(response.data.result);
                      })
                      .catch((error) => {
                        console.log(error);
                      });
                  } else {
                    setTrainingNameOptions([]);
                  }
                }}
                onChange={(e) => {
                  // if (e !== "") {
                  //   setSearchString(e);
                  // } else {
                  //   setSearchString(null);
                  // }
                }}
                isClearable={true}
                error={errors?.training}
              />
            </div>
            {/* )} */}

            <div className="mt-3 p-3 border rounded bg-gray-100 text-sm">
              <div className={`grid gap-2 grid-cols-3`}>
                <p>
                  <span className="font-semibold">Training Name : </span>
                  <span>{selectedTraining?.label}</span>
                </p>
                {/* <p>
                  <span className="font-semibold">Training Type : </span>
                  <span>{selectedTraining?.trainingType?.label}</span>
                </p> */}
                {/* {selectedTraining?.trainingType?.label === "Trainer" && (
                  <p>
                    <span>Trainer Name : </span>
                    <span className="font-semibold">Mr. Mahesh Patil</span>
                  </p>
                )} */}
              </div>
            </div>
            {/* {selectedRow?.editType === "Schedule" && (
              <div className=" my-2 gap-2 grid grid-cols-4 ">
                <DatePickerField
                  disablePast={true}
                  // defaultValue={selectedRow !== null && "12-02-2026 10:30 AM"}
                  // disabled={selectedRow?.edit}
                  name="dateTime"
                  label="Training Date*"
                  control={control}
                  inputFormat={"dd-MM-yyyy"}
                  slotProps={{ textField: { size: "small" } }}
                />
                <TimePickerField
                  control={control}
                  name={"fromTime"}
                  label={"From Time*"}
                  slotProps={{ textField: { size: "small" } }}
                />
                <TimePickerField
                  control={control}
                  name={"toTime"}
                  label={"To Time*"}
                  slotProps={{ textField: { size: "small" } }}
                />

                {selectedTraining?.trainingType?.label === "Trainer" && (
                  <div>
                    <SearchDropdown
                      onChange={() => {}}
                      handleInputChange={() => {}}
                      dataArray={employeeList}
                      control={control}
                      name="trainerName"
                      placeholder="Assign Trainer*"
                      // error={errors.trainerName}
                      isClearable
                      isSearchable
                      menuPlacement="bottom"
                      searchIcon
                      // isDisabled={isReschedule}
                    />
                  </div>
                )}
                {selectedTraining?.trainingType?.label === "Trainer" && (
                  <div className="px-1">
                    <ControlledRadioField
                      name="mode"
                      label="Mode"
                      control={control}
                      dataArray={[
                        { label: "Online", id: 1 },
                        { label: "Offline", id: 2 },
                      ]}
                    />
                  </div>
                )}
              </div>
            )} */}
            <div className="mt-3 w-1/3">
              <SearchDropdown
                dataArray={employeeNameOptions}
                control={control}
                name="employee"
                placeholder="Search Employee"
                isClearable
                isSearchable
                isDisabled={selectedRow?.editType == "View"}
                searchIcon={true}
                handleInputChange={(e) => {
                  const tempCheckChar =
                    e !== null ? UseCheckConsecutiveCharacters(e) : true;
                  if (e !== "" && tempCheckChar) {
                    getAllTrainingRecommendationEmpName(e)
                      .then((response) => {
                        setEmployeeNameOptions(response.data.result);
                      })
                      .catch((error) => {
                        console.log(error);
                      });
                  } else {
                    setEmployeeNameOptions([]);
                  }
                }}
                onChange={(e) => {
                  // if (e !== "") {
                  //   setSearchString(e);
                  // } else {
                  //   setSearchString(null);
                  // }
                }}
              />
            </div>
            <div className="mt-2 h-[240px] ">
              {tableData.length > 0 ? (
                <CommonTransactionTable
                  dataResult={tableData}
                  highlightRow={false}
                  renderActions={
                    (selectedRow?.editType == "Edit" && renderActionsEmp) ||
                    (selectedRow === null && renderActionsEmp)
                  }
                  tableClass="capitalize max-h-[241px] overflow-scroll"
                  removeHeaders={["id", "employeeId"]}
                />
              ) : (
                <div className="flex justify-center pt-6 items-center font-bold text-gray-600">
                  No Records Found...
                </div>
              )}
            </div>

            <div className=" pt-4 mt-4 flex justify-end gap-2">
              <CommonButton
                disabled={
                  selectedRow?.editType === "View" ||
                  selectedRow?.editType === "Schedule"
                }
                label="Reset"
                type="button"
                onClick={() => {
                  reset();
                  setTableData([]);
                }}
                className="px-6 py-2 border border-red-500 text-red-500"
              />
              <CommonButton
                disabled={selectedRow?.editType === "View"}
                label={selectedRow !== null ? "Update" : "Save"}
                type="submit"
                className="saveButton px-6 py-2 bg-green-700 text-white text-base"
              />
            </div>
          </form>
        </Box>
      </Modal>

      <ConfirmationModal
        confirmationOpen={openConfirmModal}
        confirmationHandleClose={() => setOpenConfirmModal(false)}
        confirmationLabel="Confirmation"
        confirmationMsg="Are you sure you want to submit training recommendation?"
        confirmationSubmitFunc={handleSaveRecord}
        confirmationButtonMsg="Submit"
      />
    </>
  );
};

export default TrainingRecommendationModal;
